import { type ReactNode, isValidElement } from 'react';

/**
 * Checks if the given value is a valid React node.
 * @param node The value to be checked.
 * @returns True if the value is a valid React node, false otherwise.
 */
export function isValidReactNode(node: unknown): node is ReactNode {
  return (
    typeof node === 'string' ||
    typeof node === 'number' ||
    typeof node === 'boolean' ||
    node === null ||
    node === undefined ||
    isValidElement(node) ||
    Array.isArray(node) ||
    typeof node === 'function'
  );
}
